/** Remove máscara do CPF. */
export function limparCpf(cpf: string): string {
  return String(cpf || '').replace(/\D/g, '')
}

/** Formata CPF como 000.000.000-00. */
export function formatarCpf(cpf: string): string {
  const d = limparCpf(cpf).slice(0, 11)
  return d
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
}

/**
 * Valida CPF pelo algoritmo oficial (dígitos verificadores).
 * Rejeita sequências iguais (000..., 111..., etc.).
 */
export function validarCpf(cpf: string): boolean {
  const numeros = limparCpf(cpf)
  if (numeros.length !== 11) return false
  if (/^(\d)\1{10}$/.test(numeros)) return false

  const calcDigito = (base: string, fatorInicial: number) => {
    let soma = 0
    for (let i = 0; i < base.length; i++) {
      soma += Number(base[i]) * (fatorInicial - i)
    }
    const resto = (soma * 10) % 11
    return resto === 10 ? 0 : resto
  }

  const d1 = calcDigito(numeros.slice(0, 9), 10)
  const d2 = calcDigito(numeros.slice(0, 10), 11)

  return d1 === Number(numeros[9]) && d2 === Number(numeros[10])
}
